import {useCallback} from "react";
import {useGet, usePost} from "@hooks/http.ts";


export type GetWalletResponse = {
    address: string;
    native?: {
        amount: string;
        at: string;
    },
    token: Array<{
        token: {
            mint: string,
            name: string,
            symbol: string,
            image?: string,
        },
        amount: string;
        at: string;
    }>
}

type GetWalletAction = (walletId: string, abortController?: AbortController) => void
export const useGetWallet = (): [
        GetWalletResponse | undefined,
    boolean,
        Error | undefined,
    GetWalletAction
] => {
    const [response, loading, error, get] = useGet<GetWalletResponse>()
    const fn = useCallback(async (walletId: string, abortController?: AbortController) =>
        get(`/v1/wallets/${walletId}`, abortController), [get]
    )
    return [response, loading, error, fn] as const;
}


export type SwapRequest = {
    from: string;
    to: string;
    amount: number;
}

export type SwapResponse = {
    signature: string;
}

type SwapAction = (walletId: string, req: SwapRequest, abortController?: AbortController) => void
export const useSwap = (): [
        SwapResponse | undefined,
    boolean,
        Error | undefined,
    SwapAction
] => {
    const [response, loading, error, post] = usePost<SwapResponse>()
    const fn = useCallback(async (walletId: string, req: SwapRequest, abortController?: AbortController) =>
        post(`/v1/wallet/${walletId}/swap`, req, abortController), [post]
    )
    return [response, loading, error, fn] as const;
}
